if (sessionStorage["ipCountryCode"] == null || sessionStorage["ipCountryCode"] == 'undefined' || sessionStorage["timezone"] == null || sessionStorage["timezone"] == 'undefined'  ) {
  fetch("https://ipinfo.io/json?token=cddd40b9477b2f")
      .then(function (response) {
          return response.json();
      })
      .then(function (data) {
          sessionStorage["ipCountryCode"] = data.country;
      });
}
else{
  console.log("Already loaded : " + sessionStorage["ipCountryCode"])
}